import React from 'react';

export default function DeliveryStep({ formData, setFormData }) {
  return (
    <div className="space-y-6">
      <h4 className="font-medium text-slate-900">Authorization and Delivery</h4>
      <div>
        <div>
          <label className="block text-sm font-medium text-slate-700 mb-1">
            Preferred Delivery
          </label>
          <select
            value={formData.deliveryMethod}
            onChange={(e) => setFormData({ ...formData, deliveryMethod: e.target.value })}
            disabled={formData.sendToAnotherProvider}
            className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
          >
            <option value="EMAIL">Email</option>
            <option value="FAX">Fax</option>
            <option value="MAIL">Mail</option>
            <option value="PORTAL">Patient Portal</option>
          </select>
          {formData.sendToAnotherProvider ? (
            <p className="text-xs text-slate-500 mt-1">
              Provider-to-provider transfer uses email delivery to the sending provider.
            </p>
          ) : (
            <p className="text-xs text-slate-500 mt-1">
              Make sure the contact info for this method is filled out above.
            </p>
          )}
        </div>
      </div>

      <div className="border border-slate-200 rounded-lg p-4 bg-slate-50">
        <label className="flex items-center gap-2 text-sm font-medium text-slate-700">
          <input
            type="checkbox"
            checked={formData.sendToAnotherProvider}
            onChange={(e) => {
              const checked = e.target.checked;
              setFormData(prev => ({
                ...prev,
                deliveryMethod: checked ? 'EMAIL' : prev.deliveryMethod,
                sendToAnotherProvider: checked,
                destinationProviderName: checked ? prev.destinationProviderName : '',
                destinationOrganization: checked ? prev.destinationOrganization : '',
                destinationDepartment: checked ? prev.destinationDepartment : '',
                destinationAddress: checked ? prev.destinationAddress : '',
                destinationCity: checked ? prev.destinationCity : '',
                destinationState: checked ? prev.destinationState : '',
                destinationPostalCode: checked ? prev.destinationPostalCode : '',
                destinationPhone: checked ? prev.destinationPhone : '',
                destinationFax: checked ? prev.destinationFax : '',
                destinationEmail: checked ? prev.destinationEmail : '',
                sendCopyToUser: checked ? true : false
              }));
            }}
          />
          Authorize provider-to-provider records transfer
        </label>
        <p className="text-xs text-slate-500 mt-1">
          We will email the sending provider and instruct them to deliver records directly to the destination provider below.
        </p>

        {formData.sendToAnotherProvider && (
          <div className="mt-4 space-y-3">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Destination Provider Name *</label>
                <input
                  type="text"
                  value={formData.destinationProviderName}
                  onChange={(e) => setFormData({ ...formData, destinationProviderName: e.target.value })}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                  placeholder="Dr. Jane Smith"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Destination Organization *</label>
                <input
                  type="text"
                  value={formData.destinationOrganization}
                  onChange={(e) => setFormData({ ...formData, destinationOrganization: e.target.value })}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                  placeholder="City Medical Center"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Destination Department</label>
              <input
                type="text"
                value={formData.destinationDepartment}
                onChange={(e) => setFormData({ ...formData, destinationDepartment: e.target.value })}
                className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                placeholder="Medical Records"
              />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Destination Email</label>
                <input
                  type="email"
                  value={formData.destinationEmail}
                  onChange={(e) => setFormData({ ...formData, destinationEmail: e.target.value })}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                  placeholder="records@provider.com"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">Destination Fax</label>
                <input
                  type="tel"
                  value={formData.destinationFax}
                  onChange={(e) => setFormData({ ...formData, destinationFax: e.target.value })}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                  placeholder="(555) 555-5555"
                />
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-slate-700 mb-1">Destination Address</label>
              <input
                type="text"
                value={formData.destinationAddress}
                onChange={(e) => setFormData({ ...formData, destinationAddress: e.target.value })}
                className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                placeholder="123 Medical Dr"
              />
            </div>
            <div className="grid grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">City</label>
                <input
                  type="text"
                  value={formData.destinationCity}
                  onChange={(e) => setFormData({ ...formData, destinationCity: e.target.value })}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">State</label>
                <input
                  type="text"
                  value={formData.destinationState}
                  onChange={(e) => setFormData({ ...formData, destinationState: e.target.value })}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                  maxLength={2}
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-slate-700 mb-1">ZIP</label>
                <input
                  type="text"
                  value={formData.destinationPostalCode}
                  onChange={(e) => setFormData({ ...formData, destinationPostalCode: e.target.value })}
                  className="w-full px-3 py-2 border border-slate-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-purple-500"
                />
              </div>
            </div>

            <label className="flex items-center gap-2 text-sm text-slate-700">
              <input
                type="checkbox"
                checked={formData.sendCopyToUser}
                onChange={(e) => setFormData({ ...formData, sendCopyToUser: e.target.checked })}
              />
              Email a copy to me
            </label>
          </div>
        )}
      </div>
    </div>
  );
}
